import useResize from '../../../../../../hooks/useResize'
import { openNewTab } from '../../../../../../utils'
import { VIEWPORT_LG } from '../../../../../../utils/constants'
import example_upload_video_hutrit_club from '../../../../images/example_upload_video_hutrit_club.webp'
import VideoExampleItem from '../../../smallComponents/VideoExampleItem/VideoExampleItem'
import example_tutorial_video from '../../../../videos/example_tutorial_video.mp4'
import Divider from '../../../../../../components/Divider'

const Example = () => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const LIST_OF_VIDEO_EXAMPLE_ITEM = [
    {
      id: 1,
      title: 'Cuida el video',
      description: (
        <>
          Cámara frontal, habla claro, con <br /> energía.
        </>
      ),
    },
    {
      id: 2,
      title: 'Enfócate en el problema',
      description: <>Explica el problema, la solución y lo que aprendiste.</>,
    },
    {
      id: 3,
      title: 'Sé preciso',
      description: 'Que no dure más de 2 minutos.',
    },
  ]

  return (
    <div className="d-flex flex-column align-items-center mt-4 w-100 px-lg-0 px-2">
      <div
        className={`${
          isMobile ? 'px-3' : 'px45'
        } py-4 d-flex flex-column align-items-center border border-2 rounded w-100 bg-bg-secondary`}
      >
        <h2 className="text-on-bg-primary text-center fw-bold">
          Video de ejemplo
        </h2>
        <h3 className="fontSize14 text-on-bg-primary">
          Ve cómo otros talentos han abordado retos similares
        </h3>
        <div className="d-flex flex-column align-items-center gap-3 mt-2">
          <img
            className="cursor-pointer"
            src={example_upload_video_hutrit_club}
            width={isMobile ? '100%' : 380}
            height={200}
            onClick={() => openNewTab({ url: example_tutorial_video })}
          />
          <div className="d-flex flex-lg-row flex-column align-items-center gap-3 mt-3">
            {LIST_OF_VIDEO_EXAMPLE_ITEM.map(({ id, title, description }) => (
              <VideoExampleItem
                key={id}
                title={title}
                description={description}
                width={294}
                customHeight={88}
              />
            ))}
          </div>
        </div>
        <Divider className="bg-on-bg-Tertiary w-100 mt-3 mb-3" />
        <span className="text-on-bg-primary text-center fw-bold fontSize20">
          ¿Quieres ideas de proyectos?
        </span>
        <span className="text-center text-on-bg-primary fontSize14">
          Te recomendamos ver{' '}
          <a
            className="text-on-bg-primary"
            href="https://www.youtube.com/watch?v=Kd0ACVCNNvM"
            target="_blank"
            rel="noreferrer"
          >
            este video
          </a>{' '}
          , y ver proyectos con ideas geniales que puedes desarrollar en poco
          tiempo en{' '}
          <a
            className="text-on-bg-primary"
            href="https://lovable.dev/projects/featured"
            target="_blank"
            rel="noreferrer"
          >
            esta página
          </a>{' '}
        </span>
        <div className="p-3 rounded border border-bg-blue bg-bg-blue-secondary d-flex  align-items-center justify-content-center w-100 mt-3">
          <span className=" fontSize14 text-center">
            Atrévete a resolver un reto real con lo que tienes a mano: un poco
            de ingenio, herramientas digitales y muchas ganas de{' '}
            <br className="d-none d-lg-flex" /> crear
          </span>
        </div>
      </div>
    </div>
  )
}

export default Example
